import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Policy({ doc }) {
    const isPrivacy = doc === "privacy";
    const title = isPrivacy ? "Privacy Policy" : "Terms of Use";
    const testid = isPrivacy ? "privacy-page" : "terms-page";

    return (
        <main data-testid={testid} className="mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-8 sm:pt-40">
            <Link
                data-testid="page-back-home"
                to="/"
                className="inline-flex items-center gap-2 text-sm text-fynary-muted transition-[color] duration-200 hover:text-white"
            >
                <ArrowLeft className="h-4 w-4" />
                Back to fynary.
            </Link>

            <h1 className="mt-8 font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">{title}</h1>

            <div className="mt-8 rounded-[24px] border border-white/10 bg-fynary-surface p-6 sm:p-10">
                <span className="inline-flex items-center gap-2 rounded-full border border-fynary-lime/30 bg-fynary-lime/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-fynary-lime">
                    <span className="h-1.5 w-1.5 rounded-full bg-fynary-lime" />
                    Coming soon
                </span>
                <p className="mt-6 text-base leading-relaxed text-fynary-muted sm:text-lg">
                    We're finalising the {title.toLowerCase()}. It will be published here shortly.
                </p>
                <p className="mt-4 text-base leading-relaxed text-fynary-muted sm:text-lg">
                    Questions in the meantime?{" "}
                    <a
                        data-testid="policy-email-link"
                        href="mailto:workfynary@gmail.com"
                        className="font-semibold text-fynary-lime transition-[opacity] duration-200 hover:opacity-80"
                    >
                        workfynary@gmail.com
                    </a>
                </p>
            </div>
        </main>
    );
}
